import { defineComponent, reactive, toRefs, ref, unref, nextTick, getCurrentInstance, watch, computed, onMounted } from "vue";
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { ElMessage, ElMessageBox, ElForm } from 'element-plus';
import { deepClone, downloadFile } from "@/utils";
import { testProcessList, addTestProcess, updateTestProcess, deleteTestProcess } from "@/api/deviceManage";
export default defineComponent({
  name: "Dict",
  components: {},
  props: {},
  setup(props) {
    const formContainer = ref(ElForm);
    const router = useRouter();
    const store = useStore();
    const userType = store.state.common.userInfo.userType;
    const tenantInfos = store.state.common.userInfo.tenantInfos || [];

    // 获取路由名称作为表格标题
    const tableTitle = computed(() => {
      const route = router.currentRoute.value;
      return route.meta?.title || route.name || '测试流程管理';
    });
    const formatCode = function (code, column) {
      if (code == 1) {
        return '启用';
      } else if (code == 0) {
        return '禁用';
      }
    };
    const state = reactive({
      tableLoading: false,
      saveLoading: false,
      dialogVisible: false,
      title: '新增测试流程',
      multipleSelection: [],
      queryParams: {
        processName: "",
        pageNum: 1,
        pageSize: 10
      },
      searchFormData: [{
        prop: "processName",
        label: "流程名称",
        placeholder: "流程名称",
        type: "text",
        isSelect: false,
        span: 4
      }],
      formHandle: [{
        label: "搜索",
        type: "primary",
        icon: "el-icon-search",
        class: "btn-liquid",
        handle: () => methods.handleQuery()
      }, {
        label: "重置",
        icon: "el-icon-refresh",
        class: "commonDarkBtn",
        handle: () => methods.resetQuery()
      }],
      //列表顶部顶部操作按钮数据
      buttonsList: [{
        buttonName: "新增",
        buttonStyle: "primary",
        hasPermi: ['testProcess:page:add'],
        className: 'addBtn',
        buttonIcon: "Plus",
        exp: item => methods.handleAdd(item)
      }
      // {
      //   buttonName: "删除",
      //   buttonStyle: "danger",
      //   hasPermi: ['system:dict:remove'],
      //   className: 'deleteBtn',
      //   buttonIcon: "Delete",
      //   exp: (item) => methods.handleDel(item),
      //   disabledHandle(row) {
      //     return state.multipleSelection.length > 0 ? false : true
      //   }
      // }
      ],
      // 请求到的表格数据
      tableData: {
        rows: [],
        total: 0
      },
      showTableHeader: [],
      tableHeader: [{
        prop: "processName",
        label: "流程名称",
        fixed: false,
        type: "text",
        clickHandle: row => {
          toRoute('/testManage/processDetail', row.id);
        }
      }, {
        prop: "processDesc",
        label: "流程描述",
        fixed: false,
        type: "text"
      }, {
        prop: "failStrategy",
        label: "失败策略",
        fixed: false,
        type: "text",
        statusList: [{
          label: '继续执行',
          value: 1
        }, {
          label: '终止流程',
          value: 0
        }]
      }, {
        prop: "processStatus",
        label: "状态",
        formatData: formatCode,
        type: function (row) {
          if (row.processStatus == 1) {
            return 'success';
          } else if (row.processStatus == 0) {
            return 'error';
          }
        }
      }, {
        prop: "createTime",
        label: "创建时间",
        fixed: false,
        type: "text"
      }, {
        prop: "operation",
        label: "操作",
        width: "150px",
        fixed: 'right',
        operation: [{
          name: "修改",
          clickFun: row => methods.handleUpdate(row),
          hasPermi: ['testProcess:page:add']
        }, {
          name: "删除",
          clickFun: row => methods.handleDel(row),
          hasPermi: ['testProcess:page:remove']
        }]
      }],
      // 表单校验
      formRules: {
        tenantId: [{
          required: true,
          message: '请选择所属租户',
          trigger: 'change'
        }],
        processName: [{
          required: true,
          message: '流程名称不能为空',
          trigger: 'blur'
        }]
      },
      form: {
        tenantId: null,
        processName: '',
        processDesc: '',
        failStrategy: 1,
        processStatus: 1
      },
      formData: [...(store.state.common.userInfo.userType == 3 ? [{
        prop: 'tenantId',
        label: '所属租户',
        placeholder: '请选择所属租户',
        type: 'list',
        filterable: true,
        options: store.state.common.userInfo.tenantInfos || [],
        props: {
          label: 'tenantName',
          value: 'tenantId'
        },
        span: 24
      }] : []), {
        prop: 'processName',
        label: '流程名称',
        placeholder: '请输入流程名称',
        type: 'text',
        isSelect: true,
        span: 24
      }, {
        prop: 'processDesc',
        label: '流程描述',
        placeholder: '请输入流程描述',
        type: 'textareaNotRemark',
        isSelect: true,
        span: 24
      }, {
        prop: 'failStrategy',
        label: '失败策略',
        type: "radio",
        isSelect: false,
        options: [{
          dictLabel: '继续执行',
          dictValue: 1
        }, {
          dictLabel: '终止流程',
          dictValue: 0
        }],
        props: {
          label: "dictLabel",
          value: "dictValue"
        },
        change: val => {},
        span: 24
      }, {
        prop: 'processStatus',
        label: '状态',
        type: 'radio',
        isSelect: false,
        options: [{
          dictLabel: '启用',
          dictValue: 1
        }, {
          dictLabel: '禁用',
          dictValue: 0
        }],
        props: {
          label: "dictLabel",
          value: "dictValue"
        },
        change: val => {},
        span: 24
      }]
    });
    // 表头初始值
    let key = router.currentRoute.value.name + ":colsettings";
    let colSettings = JSON.parse(localStorage.getItem(key));
    if (colSettings) {
      state.showTableHeader = state.tableHeader.filter(item => {
        if (item.prop == "operation") {
          return true;
        }
        if (colSettings.includes(item.prop)) {
          return true;
        }
        return false;
      });
    } else {
      state.showTableHeader = deepClone(state.tableHeader);
    }
    const toRoute = function (path, id, type, name) {
      router.push({
        path: path,
        query: {
          processId: id
        }
      });
    };
    const methods = reactive({
      close() {
        state.form = {
          tenantId: null,
          processName: '',
          processDesc: '',
          failStrategy: 1,
          processStatus: 1
        };
      },
      handleQuery() {
        methods.getList();
      },
      resetQuery() {
        state.queryParams = {
          processName: "",
          pageNum: 1,
          pageSize: 10
        }, methods.getList();
      },
      getList() {
        state.tableLoading = true;
        testProcessList(state.queryParams).then(response => {
          state.tableData.rows = response.data.records;
          state.tableData.total = response.data.total;
          state.tableLoading = false;
        });
      },
      //新增
      handleAdd() {
        state.form = {
          tenantId: userType != 3 ? window.localStorage.getItem("tenantId") : null,
          processName: '',
          processDesc: '',
          failStrategy: 1,
          processStatus: 1
        };
        state.dialogVisible = true;
        state.title = '新增测试流程';
      },
      /** 修改按钮操作 */
      handleUpdate(row) {
        state.dialogVisible = true;
        state.title = '修改测试流程';
        state.form = {
          ...row
        };
      },
      //表单确定
      submitForm: function () {
        console.log(state.form, ' state.form--');
        const formRef = unref(formContainer);
        formRef.commonForm.validate(valid => {
          if (valid) {
            state.saveLoading = true;
            if (state.form.id) {
              updateTestProcess(state.form).then(response => {
                if (response.code == 0) {
                  ElMessage.success('修改成功');
                  state.saveLoading = false;
                  state.dialogVisible = false;
                  methods.getList();
                }
              }).catch(() => {
                state.saveLoading = false;
              });
            } else {
              addTestProcess(state.form).then(response => {
                if (response.code == 0) {
                  ElMessage.success('新增成功');
                  state.dialogVisible = false;
                  state.saveLoading = false;
                  methods.resetQuery();
                }
              }).catch(() => {
                state.saveLoading = false;
              });
            }
          }
        });
      },
      //删除
      handleDel(row) {
        ElMessageBox.confirm('确定是否删除?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          return deleteTestProcess(row.id);
        }).then(res => {
          ElMessage.closeAll();
          if (res.code == 0) {
            ElMessage.success('删除成功');
          } else {
            ElMessage.warning(res.message);
          }
          methods.getList();
        }).catch(err => {
          console.log(err);
        });
      }
    });
    onMounted(() => {
      if (userType != 3) {
        state.form.tenantId = window.localStorage.getItem("tenantId");
      }
    });
    return {
      ...toRefs(state),
      ...toRefs(methods),
      ...toRefs(router),
      formContainer,
      toRoute,
      tableTitle,
      userType,
      tenantInfos
    };
  }
});